<template>
    <menu-layout>
        <router-link :to="{ name: Route.LevelSelect.name }" class="screen">
            <div class="content cr-p4">
                <div class="badge cr-ptb1 cr-plr3">{{ t('SPLASH_BADGE') }}</div>
                <h1 class="title cr-m0">{{ t('SPLASH_TITLE_MAIN') }}<span class="accent">{{ t('SPLASH_TITLE_ACCENT') }}</span></h1>
                <p class="subtitle cr-m0">{{ t('SPLASH_SUBTITLE') }}</p>
                <p class="hint cr-m0" aria-live="polite">{{ t('SPLASH_HINT') }}</p>
            </div>
        </router-link>
    </menu-layout>
</template>

<style scoped>
.screen
{
    flex: 1;
    width: 100vw;
    display: grid;
    place-items: center;
    text-decoration: none;
}

.content
{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.2rem;
    text-align: center;
}

.badge
{
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    color: var(--cr-splash-accent);
    border: 1px solid var(--cr-splash-accent-subtle);
    border-radius: var(--cr-pill-button-border-radius);
}

.title
{
    font-size: clamp(3rem, 8vw, 6rem);
    font-weight: 800;
    color: var(--cr-splash-text);
    letter-spacing: 0.04em;
    line-height: 1;
}

.accent
{
    color: var(--cr-splash-accent);
}

.subtitle
{
    font-size: 1.1rem;
    color: var(--cr-splash-text);
    max-width: 480px;
    line-height: 1.6;
}

.hint
{
    font-size: 0.8rem;
    color: var(--cr-splash-text);
    opacity: 0.6;
}
</style>

<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import Route from '../../routers/route';
import MenuLayout from '../layouts/MenuLayout.vue';
import { usePageTitle } from '../../composables/usePageTitle';
const { t } = useI18n();
const router = useRouter();

usePageTitle(computed(() => []));

function goNext(): void
{
    router.push({ name: Route.LevelSelect.name });
}

onMounted(() =>
{
    window.addEventListener('keydown', goNext, { once: true });
});

onUnmounted(() =>
{
    window.removeEventListener('keydown', goNext);
});
</script>
